// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"fc55cf24","133":"6974f532","313":"21bb4260","905":"5bae2721"}[chunkId] + ".chunk.js";
};